import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import {
  getWordpressPageBySlug,
  getEmployees
} from 'day8-react/build/content';


import {
  ComponentWrapper,
  ComponentVerticalSpacing,
  Card
} from 'day8-react/build/new-components';

import Intro from '../components/About/Intro';
import Vision from '../components/About/Vision';
import Way from '../components/About/Way';
import Partners from '../components/About/Partners';
import Team from '../components/About/Team';

import PageLayout from '../layouts/page';
import { GetStaticProps, NextPage } from 'next';
import { BgImageType, CTAType, WpPageType } from '../globalTypes';
import wp, { sanitizeWpResponse } from '../helpers/wp';

type AboutPage = {
  page: WpPageType & {
    acf: {
      intro: {},
      vision: {},
      way: {},
      partners: {},
      wwu: {
        card: {
          template: string
          imageCardTemplate: string
          heading: string
          bgImage: BgImageType
          text: string
          whiteFont: boolean
          overlay: boolean
          link: CTAType
        }
      },
    }
  }
  people: WpPageType[]
}
const About: NextPage<AboutPage> = ({ page, people }) => {
  const {
    intro,
    vision,
    way,
    partners,
    wwu
  } = page.acf;
  return (
    <PageLayout page={page}>
      <Head>
        <title>About us</title>
      </Head>
      {intro && (<Intro intro={intro} />)}
      {vision && (
        <Vision data={vision} />
      )}
      {way && (
        <Way data={way} />
      )}
      {people && (
        <Team data={people} />
      )}
      {partners && (
        <Partners data={partners} />
      )}
      {wwu && (
        <ComponentVerticalSpacing>
          <ComponentWrapper>
            <div className="max-width-sm margin-auto">
              <Card
                template={wwu.card.template}
                imageCardTemplate={wwu.card.imageCardTemplate}
                heading={wwu.card.heading}
                bgImage={wwu.card.bgImage}
                text={wwu.card.text}
                size="xs"
                whiteFont={wwu.card.whiteFont}
                overlay={wwu.card.overlay}
                link={wwu.card.link}
              />
            </div>
          </ComponentWrapper>
        </ComponentVerticalSpacing>
      )}
    </PageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const people = await getEmployees();
    const pages: WpPageType[] = await wp.pages().slug('about').get();
    return {
      props: {
        page: sanitizeWpResponse(pages[0]),
        people: people.sort((a: WpPageType, b: WpPageType) => Number(b.acf?.order) - Number(a.acf?.order))
      },
      revalidate: 300
    };
  } catch (e) {
    return { notFound: true };
  }
};

export default About;